import { deprecated, createAsyncAction } from 'typesafe-actions';
import { AxiosError } from 'axios';
import { tabImageState } from './types';
import {
  GetSearchImageParamInImageTabType,
  GetSearchImageType,
} from '../../lib/tabImage/type';

const { createAction } = deprecated;

export const SET_IS_OPEN = 'tabImage/SET_IS_OPEN' as const;
export const SET_IS_DETAIL_VIEW_OPEN = 'tabImage/SET_IS_DETAIL_VIEW_OPEN' as const;
export const SET_IMAGE_DATA = 'tabImage/SET_IMAGE_DATA' as const;
export const SET_OPEN_ROW_NUM = 'tabImage/SET_OPEN_ROW_NUM' as const;
export const SET_SELECT_PHOTO_DATA = 'tabImage/SET_SELECT_PHOTO_DATA' as const;

export const GET_SEARCH_IMAGE = 'tabImage/GET_SEARCH_IMAGE' as const;
export const GET_SEARCH_IMAGE_SUCCESS = 'tabImage/GET_SEARCH_IMAGE_SUCCESS' as const;
export const GET_SEARCH_IMAGE_ERROR = 'tabImage/GET_SEARCH_IMAGE_ERROR' as const;

export const SET_ADD_IMAGE = 'tabImage/SET_ADD_IMAGE' as const;

export const SET_IMAGE_DATA_NULL = 'tabImage/SET_IMAGE_DATA_NULL' as const;

export const setIsDetailViewOpen = createAction(
  SET_IS_DETAIL_VIEW_OPEN,
  (action) => (isDetailViewOpen: tabImageState['isDetailViewOpen']) =>
    action(isDetailViewOpen)
);

export const setIsOpen = createAction(
  SET_IS_OPEN,
  (action) => (isOpenStatus: tabImageState['isOpenStatus']) =>
    action(isOpenStatus)
);

export const setImageData = createAction(
  SET_IMAGE_DATA,
  (action) => (photosData: tabImageState['photosData']) => action(photosData)
);

export const setOpenRowNum = createAction(
  SET_OPEN_ROW_NUM,
  (action) => (openRow: tabImageState['openRow']) => action(openRow)
);

export const setSelectPhotoData = createAction(
  SET_SELECT_PHOTO_DATA,
  (action) => (selectPhotoData: tabImageState['selectPhotoData']) =>
    action(selectPhotoData)
);

export const setAddImage = createAction(
  SET_ADD_IMAGE,
  (action) => (addImageData: tabImageState['addImageData']) =>
    action(addImageData)
);

export const getSearchImageAsyncInImageTab = createAsyncAction(
  GET_SEARCH_IMAGE,
  GET_SEARCH_IMAGE_SUCCESS,
  GET_SEARCH_IMAGE_ERROR
)<GetSearchImageParamInImageTabType, GetSearchImageType, AxiosError>();

export const setImageDataNull = createAction(SET_IMAGE_DATA_NULL);
